import { render } from "./ImageView.vue?vue&type=template&id=0ba0a4d6&scoped=true"
import script from "./ImageView.vue?vue&type=script&lang=js"
export * from "./ImageView.vue?vue&type=script&lang=js"

import "./ImageView.vue?vue&type=style&index=0&id=0ba0a4d6&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba0a4d6"]])

export default __exports__